/**
 * Форматирует номер телефона для красивого отображения
 * Преобразует +79649060090 в +7(964)906-00-90
 */
export function formatPhoneDisplay(phone: string | null | undefined): string {
  if (!phone) return '';
  
  // Временно отключено форматирование - возвращаем как есть
  return phone;
  
  // Закомментированный код для красивого форматирования:
  // // Удаляем все символы кроме цифр
  // const digits = phone.replace(/\D/g, '');
  // 
  // // Проверяем что это российский номер (11 цифр, начинается с 7)
  // if (digits.length === 11 && digits.startsWith('7')) {
  //   const countryCode = digits.slice(0, 1);  // 7
  //   const operatorCode = digits.slice(1, 4); // 964
  //   const firstPart = digits.slice(4, 7);    // 906
  //   const secondPart = digits.slice(7, 9);   // 00
  //   const thirdPart = digits.slice(9, 11);   // 90
  //   
  //   return `+${countryCode}(${operatorCode})${firstPart}-${secondPart}-${thirdPart}`;
  // }
  // 
  // // Если формат не подходит, возвращаем исходный
  // return phone;
}